import React from "react";
import { useUserContext } from "context/UserContext";
import ExposureSP from "layouts/SP/exposure";

function Exposures() {
  const { role } = useUserContext() || {};
  if (role === "SP") {
    return <ExposureSP />;
  }
  return null;
}

export default Exposures;
